import { MyProfileData } from 'common';
import { AbstractDataState, useGetSimpleApiData } from '@cp-shared-10/frontend-integration';
import { fetchMyProfile } from './MyProfileSlice';
import { MyProfileDataSelector } from './MyProfileDataSelector';
import { DefaultBusinessMarketApiErrorCode } from '@cp-shared-10/common-utilities';

export function useMyProfile(): AbstractDataState<MyProfileData, DefaultBusinessMarketApiErrorCode> {
    return useGetSimpleApiData(fetchMyProfile, MyProfileDataSelector);
}
